export default "__VITE_ASSET__DPZq2cEZ__"